const reducer = state => ({
  ...state,
  errorStatusCode: null,
  errorCount: 0,
  errorSource: null,
});

export default reducer;
